import React, { useEffect } from 'react';
import ValidatedFormInput from 'components/ValidatedFormInput';
import validator from 'validator';
import {
  Grid,
  Form,
  Button,
  Checkbox,
  Container,
  Dimmer,
  Loader,
  Icon,
} from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getAllRoles,
  setCheckField,
  createNewInternalUser,
  setCreatingUserState,
} from 'state/access/actions';
import { SemanticToastContainer } from 'react-semantic-toasts';

const emptyStringValidation = (value = '') =>
  !validator.isEmpty(value) ? undefined : 'This field is required';

const emailValidation = value =>
  validator.isEmail(value) ? undefined : 'Invalid email address';

const passwordValidation = value => {
  if (value) {
    if (value.length < 6)
      return 'Invalid password, password must be at least 6 characters';
  }
  return undefined;
};

const CreateInternalUserForm = props => {
  const { dispatch, allRoles, handleSubmit, creatingUser } = props;

  const onCreateUserSubmit = ({ email, password }) => {
    dispatch(setCreatingUserState(true));
    const payload = { email, password };
    payload.role_ids = allRoles
      .filter(role => role.isChecked)
      .map(role => role.id);
    dispatch(createNewInternalUser(payload));
  };
  const handleCheckFieldChange = index => {
    dispatch(setCheckField({ index, currRoles: allRoles }));
  };

  useEffect(() => {
    dispatch(getAllRoles({ initialState: [] }));
  }, [dispatch]);

  return (
    <Container>
      <SemanticToastContainer />
      <Dimmer active={creatingUser}>
        <Loader size="massive">Saving</Loader>
      </Dimmer>
      <Form onSubmit={handleSubmit(onCreateUserSubmit)}>
        <Field
          id="email"
          name="email"
          component={ValidatedFormInput}
          icon="user"
          iconPosition="left"
          placeholder="Email"
          autoFocus
          validate={[emptyStringValidation, emailValidation]}
        />
        <Field
          id="password"
          name="password"
          component={ValidatedFormInput}
          icon="lock"
          iconPosition="left"
          placeholder="Password"
          type="password"
          validate={[emptyStringValidation, passwordValidation]}
        />
        <h3>Roles</h3>
        <Grid>
          {allRoles.map((role, index) => (
            <Grid.Column key={role.id} mobile={16} tablet={8} computer={4}>
              <Checkbox
                key={role.id}
                checked={role.isChecked}
                label={role.name}
                onChange={() => handleCheckFieldChange(index)}
              />
            </Grid.Column>
          ))}
        </Grid>
        <br />
        <Container>
          <Button type="submit" primary inverted>
            <Icon name="save" />
            Save
          </Button>
        </Container>
      </Form>
    </Container>
  );
};

const mapStateToProps = ({ access }) => ({
  addUserModal: access.addUserModal,
  allRoles: access.allRoles,
  creatingUser: access.creatingUser,
});

CreateInternalUserForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  allRoles: PropTypes.array.isRequired,
  creatingUser: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'create_new_user',
  })(CreateInternalUserForm)
);
